import { render, staticRenderFns } from "./UserFormActions.vue?vue&type=template&id=4a1ce1ce&scoped=true&"
import script from "./UserFormActions.vue?vue&type=script&lang=js&"
export * from "./UserFormActions.vue?vue&type=script&lang=js&"
import style0 from "./UserFormActions.vue?vue&type=style&index=0&id=4a1ce1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ce1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a1ce1ce')) {
      api.createRecord('4a1ce1ce', component.options)
    } else {
      api.reload('4a1ce1ce', component.options)
    }
    module.hot.accept("./UserFormActions.vue?vue&type=template&id=4a1ce1ce&scoped=true&", function () {
      api.rerender('4a1ce1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFormActions.vue"
export default component.exports